import { useState } from 'react'

import VisibilityOnIcon from '@/assets/icons/icon-visibility-on.svg'
import { CreatorBrowserLink } from '@/components/ui/CreatorBrowserLink.tsx'
import type { SpendingCustomerListContent } from '@/modules/tracking/new-subscriber-analysis/types.ts'
import { classNames } from '@/utils/helpers'

interface Props {
  row: SpendingCustomerListContent
}
export const ViewCustomerListAction = ({ row }: Props) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CreatorBrowserLink
        href={`https://onlyfans.com/my/chats/chat/${row.fanId}`}
      >
        <a
          target="_blank"
          rel="noreferrer"
          className={classNames(
            'flex items-center gap-2 rounded-lg px-4 py-2 text-primary-500',
            {
              'text-inherit': !isHovered,
            },
          )}
        >
          <VisibilityOnIcon className="h-6 w-6 fill-green-600" />
        </a>
      </CreatorBrowserLink>
    </div>
  )
}
